import React from 'react';
import SectionHeader from '../../Basic/SectionHeader';
import Select from '../../Basic/Select';

const sectionStyle = {
    width: "550px",
    height: "395px",
    backgroundImage: "url(../../images/HouseGraphic.png)",
    backgroundSize: "contain"
};
const MeterImage = () => { return (<img src="../../images/MeterIcon.png" style={{ width: "20%" }} />); };

class MeterLocation extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    onChange(position) {
        this.setState({
            position
        });
    }
    render() {
        const p = this.props;
        const lookup = window.osa.lookup.projectSpecifics.meterLocation;

        return (
            <div>
                <div className="row">
                    <div className="col-sm-6">
                        <SectionHeader title={lookup.title} required />
                        <p dangerouslySetInnerHTML={{ __html: lookup.text }} />
                        <Select name="meterLocation" items={lookup.items} placeHolder={lookup.placeHolder} onChange={(position) => this.onChange(position)} />
                    </div>
                    <div className="col-sm-6">
                        <div style={sectionStyle} >
                            <table style={{ width: "100%", height: "80%", border: "1px", tableLayout: "fixed" }}>
                                <tbody>
                                    <tr><td>{this.state.position == 'BL' ? <MeterImage /> : null}</td><td>&nbsp;</td><td style={{ textAlign: "right" }}>{this.state.position == 'BR' ? <MeterImage /> : null}</td></tr>
                                    <tr><td>{this.state.position == 'LHS' ? <MeterImage /> : null}</td><td>&nbsp;</td><td style={{ textAlign: "right" }}>{this.state.position == 'RHS' ? <MeterImage /> : null}</td></tr>
                                    <tr><td>{this.state.position == 'FL' ? <MeterImage /> : null}</td><td>&nbsp;</td><td style={{ textAlign: "right" }}>{this.state.position == 'FR' ? <MeterImage /> : null}</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default MeterLocation;